import BaseStep from './BaseStep.js';
import {Helper} from "../../helpers/Helper.js";

export default class CRMFlow extends BaseStep{

	#startDateTimestamp
    _init() {

        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#events()
        },0);

		this._MultiStepForms.Hook.addAction('init', () => {

		});

		this._MultiStepForms.Hook.addFilter('errorMessage', (message, field, form) => {
			if (field?.name?.includes('living')) {
				return message.replace(/(L|l)iving/g, '');
			} else if (['membership_id', 'membership_type'].includes(field?.name)) {
				return wp.i18n.__('Please select an membership', 'levcharity')
			}

			return message;
		});

		this._MultiStepForms.Hook.addAction('submitFormSuccess', (response, form, formAction) => {
			if (formAction === 'levcharity_create_user') {
				this.#setAddresses(form);
				this.#setWhatsappNumber(form);
			}
		})
    }

    #events() {
		this._MultiStepForms.handleEvent('change', 'input[type="radio"][name="membership_id"]', (event, radio) => {
			const item = radio.closest('.variation-item')
			const wrapper = item.closest('.variations-wrapper')
			const typeInput = wrapper?.querySelector('input[name="membership_type"]')

			if (typeInput) {
				typeInput.value = item.dataset.membershipType;

				const changeEvent = new Event('change', {
					bubbles: true, // Allow the event to bubble up
					cancelable: true, // Allow the event to be cancelable
				});

				// Dispatch the event
				typeInput.dispatchEvent(changeEvent);
			}
		})
    }

	#setAddresses(registerForm) {
		const addresses = {
			billing_country : 'living_country',
			address: 'living_address',
			billing_state: 'living_state',
			billing_city: 'living_city',
		};

		for (const billingName in addresses) {
			const livingName = addresses[billingName];

			const billingField = registerForm.querySelector(`[name="${billingName}"]:not([disabled])`);
			const livingField = this._MultiStepForms.formWrapper.querySelector(`[name="${livingName}"]:not([disabled])`);

			if (livingField && billingField) {
				livingField.value = billingField.value;

				const changeEvent = new Event('change', {
					bubbles: true, // Allow the event to bubble up
					cancelable: true, // Allow the event to be cancelable
				});

				// Dispatch the event
				livingField.dispatchEvent(changeEvent);
			}
		}
	}

	#setWhatsappNumber(registerForm) {
		const phoneNumber = registerForm.querySelector(`[name="phone_number"]:not([disabled])`);
		const phoneNumberCode = registerForm.querySelector(`[name="country_code_number"]:not([disabled])`);

		const whatsappNumber = this._MultiStepForms.formWrapper.querySelector(`[name="whatsapp_number"]:not([disabled])`);

		if (phoneNumber && phoneNumberCode && whatsappNumber) {
			whatsappNumber.value = '+' + phoneNumberCode.value + ' ' + phoneNumber.value;

			const changeEvent = new Event('change', {
				bubbles: true, // Allow the event to bubble up
				cancelable: true, // Allow the event to be cancelable
			});

			// Dispatch the event
			whatsappNumber.dispatchEvent(changeEvent);
		}
	}
}
